var PageResult = /** @class */ (function () {
    function PageResult() {
        /**
         * Total number of records available.
         */
        this.total = 0;
        /**
         * The page data.
         */
        this.entityList = [];
    }
    return PageResult;
}());
export { PageResult };
